export class HowToPlayView {
  constructor(container, { onClose }) {
    this.container = container;
    this.onClose = onClose;
    this.element = null;
    this.init();
  }

  init() {
    this.element = document.createElement('div');
    this.element.className = 'ui-view how-to-play-view hidden modal-backdrop';

    const card = document.createElement('div');
    card.className = 'card-panel';
    card.style.maxWidth = '480px';
    card.style.width = '100%';

    const title = document.createElement('h2');
    title.className = 'text-heading';
    title.textContent = 'HOW TO PLAY';
    title.style.marginBottom = '16px';
    title.style.textAlign = 'center';
    card.appendChild(title);

    // Gameplay Objective
    const objective = document.createElement('p');
    objective.className = 'text-secondary';
    objective.style.marginBottom = '20px';
    objective.style.textAlign = 'center';
    objective.textContent = 'Sprint down 3 neon lanes, avoid hazard barriers, leap over low hurdles, and collect energy orbs to climb the leaderboard.';
    card.appendChild(objective);

    // Controls Table
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.marginBottom = '24px';
    table.style.borderCollapse = 'collapse';

    const controls = [
      { action: 'Move Left', desktop: 'A or ←', mobile: 'Swipe Left / ◀' },
      { action: 'Move Right', desktop: 'D or →', mobile: 'Swipe Right / ▶' },
      { action: 'Jump', desktop: 'Space or ↑', mobile: 'Swipe Up / JUMP' },
      { action: 'Pause', desktop: 'Esc or P', mobile: '⏸ Button' },
    ];

    for (const ctrl of controls) {
      const tr = document.createElement('tr');
      tr.style.borderBottom = '1px solid rgba(255, 255, 255, 0.08)';

      const tdAction = document.createElement('td');
      tdAction.style.padding = '8px 4px';
      tdAction.style.fontWeight = '700';
      tdAction.textContent = ctrl.action;
      tr.appendChild(tdAction);

      const tdDesktop = document.createElement('td');
      tdDesktop.style.padding = '8px 4px';
      tdDesktop.className = 'text-secondary';
      tdDesktop.textContent = ctrl.desktop;
      tr.appendChild(tdDesktop);

      const tdMobile = document.createElement('td');
      tdMobile.style.padding = '8px 4px';
      tdMobile.className = 'text-muted';
      tdMobile.style.fontSize = '0.9rem';
      tdMobile.textContent = ctrl.mobile;
      tr.appendChild(tdMobile);

      table.appendChild(tr);
    }
    card.appendChild(table);

    // Hazards Guide
    const hazardsBox = document.createElement('div');
    hazardsBox.style.background = 'var(--color-surface-raised)';
    hazardsBox.style.padding = '12px 16px';
    hazardsBox.style.borderRadius = 'var(--radius-control)';
    hazardsBox.style.marginBottom = '20px';
    hazardsBox.style.fontSize = '0.9rem';

    const hItem1 = document.createElement('div');
    hItem1.style.marginBottom = '6px';
    hItem1.innerHTML = '🟥 <strong style="color: var(--color-danger)">Red Blocker:</strong> Full barrier. Switch lanes to avoid.';
    hazardsBox.appendChild(hItem1);

    const hItem2 = document.createElement('div');
    hItem2.style.marginBottom = '6px';
    hItem2.innerHTML = '🟨 <strong style="color: var(--color-warning)">Yellow Hurdle:</strong> Low barrier. Jump over it or switch lanes.';
    hazardsBox.appendChild(hItem2);

    const hItem3 = document.createElement('div');
    hItem3.innerHTML = '⚡ <strong style="color: var(--color-collectible)">Energy Orb:</strong> +1 Point each. Collect them all!';
    hazardsBox.appendChild(hItem3);

    card.appendChild(hazardsBox);

    // Close Button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'btn-primary';
    closeBtn.style.width = '100%';
    closeBtn.textContent = 'Got It!';
    closeBtn.onclick = () => this.onClose();
    card.appendChild(closeBtn);

    this.element.appendChild(card);
    this.container.appendChild(this.element);
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
